import moment from 'moment-timezone';

export class ViewEnterpriseDashboardPerformanceMonth {
	public contractId: string;
	public originContractId: string;
	public agentId: string;
	public contractNum: string;
	public originContractNum: string;
	public effectiveDate: Date;
	public expirationDate: Date;
	public confirmationDate: Date;
	public productId: string;
	public productName: string;
	public dbaName: string;
	public supplierId: string;
	public supplierName: string;
	public utilityIdList: string;
	public utilityNameList: string;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public address1: string;
	public address2: string;
	public city: string;
	public stateId: string;
	public stateShort: string;
	public zipCode: string;
	public countryId: number;
	public countryName: string;
	public date: Date;
	public contractBaseRate: number;
	public usage: number;
	public hedgedUsage: number;
	public supplyRate: number;
	public supplyCost: number;
	public utilityRate: number;
	public utilityCost: number;
	public costAvoidance: number;

	constructor(viewEnterpriseDashboardPerformanceMonth: ViewEnterpriseDashboardPerformanceMonth) {
		Object.assign(this, viewEnterpriseDashboardPerformanceMonth);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY 00:00:00 a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY 00:00:00 a')) : this.expirationDate;
		this.confirmationDate = this.confirmationDate ? new Date(moment(this.confirmationDate).format('MMM DD, YYYY 00:00:00 a')) : this.confirmationDate;
	}
}
